module.exports = __webpack_public_path__ + "static/media/how-are-you-managing-your-mental-health-news.431f095d.jpg";